// Base URLs


// API base URLs
export const BASE_URL = import.meta.env.VITE_BASE_URL;

export const API_BASE_URL = `${BASE_URL}/api`;

// Asset paths
export const PROFILE_PICTURES_PATH = `${BASE_URL}/profile-pictures`;
export const ARTICLE_MENUSCRIPT_PATH = `${BASE_URL}/articles/menu-script`;
export const ARTICLE_COVER_LETTER_PATH = `${BASE_URL}/articles/cover-letter`;
export const ARTICLE_SUPPLEMENTARY_FILE_PATH = `${BASE_URL}/articles/supplementary-file`;

// Placeholder images
export const DEFAULT_PROFILE_IMAGE = "profile-logo.png"; // Default profile image name

